// Spanish translations
export const es: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Tablero',
  'menu.orderNew': 'Nuevo Pedido',
  'menu.deliveryList': 'Lista de Entregas',
  'menu.delivery': 'Entrega',
  'menu.receipt': 'Imprimir Recibo',
  'menu.carWash': 'Lavado de autos',
  'menu.referral': 'Invitar',
  'menu.barber': 'Barbería / Peluquería',
  
  // Definitions
  'menu.definitions': 'Definiciones',
  'menu.customers': 'Clientes',
  'menu.products': 'Definiciones de Productos',
  'menu.pricing': 'Definiciones de Precios',
  'menu.tailoring': 'Sastrería',
  'menu.attributes': 'Atributos de Producto',
  'menu.users': 'Usuarios',
  'menu.productOrdering': 'Orden de Productos',
  'menu.discounts': 'Definiciones de Descuentos',
  
  // Settings
  'menu.settings': 'Configuración',
  'menu.generalSettings': 'Configuración General',
  'menu.permissions': 'Gestión de Permisos',
  'menu.subscription': 'Suscripción',
  'menu.invoices': 'Gestión de Facturas',
  'menu.expenses': 'Gastos',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Informes y Contabilidad',
  'menu.systemAndCommunication': 'Sistema y Comunicación',
  'menu.reportsList': 'Lista de Recibos',
  'menu.accountStatement': 'Estado de Cuenta',
  'menu.tickets': 'Tickets de Soporte',
  'menu.support': 'Soporte',
  'menu.profile': 'Perfil',
  'menu.logout': 'Cerrar Sesión',
  'menu.notifications': 'Notificaciones SMS/WhatsApp',
  'menu.whatsappConnection': 'Conexión WhatsApp',
  'menu.smsConnection': 'Conexión SMS',
  
  // Dashboard
  'dashboard.title': 'Tablero',
  'dashboard.todaySales': 'Ventas de Hoy',
  'dashboard.totalOrders': 'Pedidos Totales',
  'dashboard.pendingDeliveries': 'Entregas Pendientes',
  'dashboard.activeCustomers': 'Clientes Activos',
  'dashboard.recentOrders': 'Pedidos Recientes',
  'dashboard.viewAll': 'Ver Todo',
  'dashboard.quickActions': 'Acciones Rápidas',
  'dashboard.newOrder': 'Nuevo Pedido',
  'dashboard.newCustomer': 'Nuevo Cliente',
  'dashboard.deliveries': 'Entregas',
  'dashboard.reports': 'Informes',
  'dashboard.today': 'Hoy',
  'dashboard.yesterday': 'Ayer',
  'dashboard.week': 'Semana',
  'dashboard.month': 'Mes',
  'dashboard.quarter': 'Trimestre',
  'dashboard.year': 'Año',
  'dashboard.totalRevenue': 'Ingresos Totales',
  'dashboard.totalPieces': 'Piezas Totales',
  'dashboard.cancelled': 'Cancelado',
  'dashboard.inProcess': 'En Proceso',
  'dashboard.inProcessDesc': 'Pedidos en proceso',
  'dashboard.ready': 'Listo',
  'dashboard.readyDesc': 'Listo para entrega',
  'dashboard.delivered': 'Entregado',
  'dashboard.deliveredDesc': 'Pedidos completados',
  'dashboard.announcements': 'Anuncios',
  'dashboard.announcementAll': 'General',
  'dashboard.announcementPrivate': 'Privado',
  'dashboard.referral.title': 'Invita a Tu Amigo',
  'dashboard.referral.desc': '¡1 mes extra cuando un negocio invitado se registre!',
  'dashboard.referral.button': 'Invitar Ahora',
  
  // Settings Page
  'settings.title': 'Configuración',
  'settings.general': 'Configuración General',
  'settings.companyName': 'Nombre de la Empresa',
  'settings.language': 'Idioma',
  'settings.currency': 'Moneda',
  'settings.currencyPosition': 'Posición de Moneda',
  'settings.currencyPositionLeft': 'Izquierda ($100.00)',
  'settings.currencyPositionRight': 'Derecha (100.00₺)',
  'settings.currencyPositionPreviewLeft': 'Símbolo a la izquierda',
  'settings.currencyPositionPreviewRight': 'Símbolo a la derecha',
  'settings.numberFormat': 'Formato de Número',
  'settings.currencyFormat': 'Formato de Moneda',
  'settings.showDecimals': 'Mostrar Decimales',
  'settings.showDecimalsDesc': 'Mostrar parte decimal (centavos) en los precios',
  'settings.dateFormat': 'Formato de Fecha',
  'settings.timezone': 'Zona Horaria',
  'settings.deliveryDays': 'Tiempo de Entrega (Días)',
  'settings.workOnSunday': 'Trabajar los Domingos',
  'settings.defaultServiceType': 'Tipo de Servicio Predeterminado',
  'settings.defaultServiceTypeDesc': 'El tipo de servicio que se seleccionará automáticamente cuando se abra la pantalla de entrada de productos',
  'settings.defaultCategory': 'Categoría Predeterminada',
  'settings.defaultCategoryDesc': 'La categoría que se seleccionará automáticamente cuando se abra la pantalla de entrada de productos',
  'settings.companyLogo': 'Logo de la Empresa',
  'settings.logoDescription': 'El logo aparecerá en los recibos y en la parte superior izquierda del programa. Tamaño recomendado: 200x80px',
  'settings.uploadLogo': 'Subir Logo',
  'settings.removeLogo': 'Eliminar Logo',
  'settings.noLogo': 'Sin logo',
  'settings.receiptSettings': 'Configuración del Recibo',
  'settings.taxRate': 'Tasa de Impuesto (%)',
  'settings.receiptFooterText': 'Texto del Pie del Recibo',
  'settings.receiptNote': 'Pie del Recibo (Notas)',
  'settings.socialMedia': 'Redes Sociales y Contacto',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Sitio Web',
  'settings.phone': 'Teléfono',
  'settings.address': 'Dirección',
  'settings.dangerZone': 'Zona de Peligro',
  'settings.deleteDemoDataWarning': 'Elimina los clientes de ejemplo añadidos automáticamente en la configuración, junto con sus recibos y pagos. Los clientes y recibos que usted añadió no se eliminan.',
  'settings.productsWillBeKept': 'Las definiciones de productos se conservarán.',
  'settings.deleteDemoDataTitle': 'Los Datos de Demostración Serán Eliminados',
  'settings.deleteDemoDataConfirm': '¡Esta acción no se puede deshacer! Se eliminarán los clientes de ejemplo y sus recibos/pagos; sus propios clientes y recibos se conservarán.',
  'toast.noDemoData': 'No hay clientes de ejemplo para eliminar.',
  'toast.demoCustomersKept': '{n} cliente(s) de ejemplo conservado(s) porque tienen recibos creados por usted; solo se eliminaron sus recibos de ejemplo.',
  'settings.areYouSure': '¿Está seguro de que desea continuar?',
  'settings.deleting': 'Eliminando...',
  'settings.yesDelete': 'Sí, Eliminar',
  'settings.deleteDemoData': 'Eliminar Datos de Demostración',
  'settings.save': 'Guardar',
  'settings.loading': 'Cargando...',
  'settings.languageRegion': 'Idioma y región',
  'settings.numberFormatDotComma': 'Punto para decimales (1.234,56)',
  'settings.numberFormatCommaDot': 'Coma para decimales (1,234.56)',
  'settings.numberFormatSpaceComma': 'Espacio para decimales (1 234,56)',
  'settings.logo': 'Logo',
  'settings.companyNamePlaceholder': 'Ingrese el nombre de la empresa',
  'settings.addressPlaceholder': 'Ingrese la dirección',
  'settings.footerText': 'Texto de pie de página',
  'settings.footerTextPlaceholder': 'Ingrese el texto de pie de página',
  'settings.receiptNotePlaceholder': 'Ingrese la nota del recibo',
  'settings.loadSchema': 'Cargar esquema',
  'settings.loadSchemaTitle': 'Cargar esquema de base de datos',
  'settings.loadSchemaConfirm': 'Esto creará el esquema de base de datos. ¿Continuar?',
  'settings.connected': 'Conectado',
  'settings.notConnected': 'No conectado',
  'settings.connect': 'Conectar',
  'settings.disconnect': 'Desconectar',
  'settings.showTax': 'Mostrar impuesto',
  'settings.headerInfo': 'Info de encabezado',
  'settings.headerInfoPlaceholder': 'ej: Limpieza en seco y Planchado',
  'settings.footerTextHelp': 'Mensaje corto que aparece en la parte inferior del recibo',
  'settings.receiptNoteHelp': 'Términos y condiciones detallados',
  'settings.receiptPreview': 'Vista previa del recibo',
  
  // Toasts
  'toast.settingsSaved': 'Configuración guardada',
  'toast.settingsError': 'Error al guardar la configuración',
  'toast.settingsLoadError': 'Error al cargar la configuración',
  'toast.logoUploaded': 'Logo subido. ¡No olvides guardar!',
  'toast.logoRemoved': 'Logo eliminado. ¡No olvides guardar!',
  'toast.logoSizeError': 'El archivo del logo debe ser menor de 500KB',
  'toast.logoTypeError': 'Solo se pueden subir archivos de imagen',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'Conexión WhatsApp',
  'whatsapp.subtitle': 'Administre su conexión de WhatsApp Business API',
  'whatsapp.connectionStatus': 'Estado de Conexión',
  'whatsapp.disconnected': 'Desconectado',
  'whatsapp.notConnectedMessage': 'Su cuenta de WhatsApp aún no está conectada',
  'whatsapp.connectWithQR': 'Conectar con Código QR',
  'whatsapp.importantInfo': 'Información Importante',
  'whatsapp.info1': '1. Escanee el código QR con la aplicación WhatsApp de su teléfono',
  'whatsapp.info2': '2. Puede enviar mensajes automáticos después de la conexión',
  'whatsapp.info3': '3. Para desconectar, cierre sesión desde la configuración de WhatsApp',
  'whatsapp.info4': '4. El código QR se actualizará automáticamente después de 60 segundos',
  'whatsapp.generateQR': 'Generar Código QR',
  
  // Common
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.save': 'Guardar',
  'common.search': 'Buscar',
  'common.loading': 'Cargando...',
  'common.noData': 'Sin datos',
  'common.actions': 'Acciones',
  'common.status': 'Estado',
  'common.date': 'Fecha',
  'common.time': 'Hora',
  'common.total': 'Total',
  'common.close': 'Cerrar',
  'common.back': 'Atrás',
  'common.submit': 'Enviar',
  'common.create': 'Crear',
  'common.creating': 'Creando...',
  'common.later': 'Más tarde',
  
  // Tickets
  'tickets.title': 'Tickets de Soporte',
  'tickets.newTicket': 'Nuevo Ticket',
  'tickets.noTickets': 'Aún no hay tickets de soporte',
  'tickets.noTicketsDesc': 'Si tiene un problema, puede crear un nuevo ticket de soporte',
  'tickets.subject': 'Asunto',
  'tickets.description': 'Descripción',
  'tickets.yourName': 'Su Nombre',
  'tickets.yourNamePlaceholder': 'Ingrese su nombre',
  'tickets.subjectPlaceholder': 'Resume brevemente su problema',
  'tickets.descriptionPlaceholder': 'Describa su problema en detalle',
  'tickets.created': 'Ticket de soporte creado',
  'tickets.createError': 'No se pudo crear el ticket de soporte',
  'tickets.fillAllFields': 'Completa todos los campos',
  'tickets.loadError': 'No se pudieron cargar los tickets',
  'tickets.messages': 'mensajes',
  'tickets.status.open': 'Abierto',
  'tickets.status.investigating': 'Investigando',
  'tickets.status.waitingCustomer': 'Esperando al Cliente',
  'tickets.status.closed': 'Resuelto',
  'tickets.conversation': 'Conversación',
  'tickets.admin': 'Equipo de Soporte',
  'tickets.typeMessage': 'Escriba su mensaje...',
  'tickets.sendError': 'No se pudo enviar el mensaje',
  'tickets.closedMessage': 'Este ticket ha sido marcado como resuelto.',
  'tickets.rateSupport': 'Calificar Soporte',
  'tickets.rateExperience': 'Califique su Experiencia',
  'tickets.rateDescription': '¿Cómo calificaría el soporte que recibió?',
  'tickets.selectRating': 'Por favor seleccione una calificación',
  'tickets.ratingSubmitted': '¡Su calificación ha sido guardada, gracias!',
  'tickets.ratingError': 'No se pudo enviar la calificación',
  'tickets.yourRating': 'Su Calificación',
  'tickets.rating.veryBad': 'Muy Malo',
  'tickets.rating.bad': 'Malo',
  'tickets.rating.okay': 'Regular',
  'tickets.rating.good': 'Bueno',
  'tickets.rating.excellent': 'Excelente',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Sistema de Gestión de Lavandería',
  'login.tenantId': 'ID de Empresa',
  'login.tenantPlaceholder': 'id-empresa (ej: acme-clean)',
  'login.tenantIdHelp': 'Ingrese su identificador único de empresa',
  'login.continue': 'Continuar →',
  'login.notMember': '¿Aún no es miembro?',
  'login.startTrial': 'Iniciar Prueba Gratuita',
  'login.adminLogin': '🔒 Inicio de Sesión Administrador',
  'login.enterPin': 'Ingrese su código PIN',
  'login.changeTenant': 'Cambiar Empresa',
  'login.clear': 'Limpiar',
  'login.delete': 'Eliminar',
  'login.login': 'Iniciar Sesión',
  'login.loggingIn': 'Iniciando sesión...',
  'login.defaultPinOwner': 'PIN predeterminado: <strong>1234</strong> (Propietario)',
  'login.defaultPinCashier': 'PIN predeterminado: <strong>0000</strong> (Cajero)',
  'login.systemInitializing': 'Sistema inicializando...',
  'login.pinMinLength': 'El PIN debe tener al menos 4 dígitos',
  'login.invalidTenantId': 'Ingrese un ID de Empresa válido',
  'login.tenantNotFound': 'Este código de empresa no se encontró. Por favor verifique o cree una nueva cuenta.',
  'login.loginFailed': 'Error de inicio de sesión',
  'login.welcome': 'Bienvenido, {name}',

  // Signup translations
  'signup.title': 'Iniciar Prueba Gratuita',
  'signup.subtitle': 'Prueba gratis durante 15 días, no se requiere tarjeta de crédito',
  'signup.referral.title': '¡Invitado por un Amigo! 🎉',
  'signup.referral.bonus': '¡30 días de prueba gratuita son tuyos!',
  'signup.referral.text': '¡Como fuiste invitado, tienes 30 días completamente gratis!',
  'signup.back': 'Atrás',
  'signup.backToLogin': 'Volver al Inicio de Sesión',
  'signup.plans.starter.name': 'Inicio',
  'signup.plans.starter.features.receipts': 'Recibos Ilimitados',
  'signup.plans.starter.features.customers': '100 Clientes',
  'signup.plans.starter.features.whatsapp': 'Notificaciones WhatsApp',
  'signup.plans.starter.features.reports': 'Reportes',
  'signup.plans.starter.features.support': 'Soporte por Email',
  'signup.plans.professional.name': 'Profesional',
  'signup.plans.professional.features.unlimited': 'Clientes Ilimitados',
  'signup.plans.professional.features.delivery': 'Seguimiento de Entrega',
  'signup.plans.professional.features.inventory': 'Gestión de Inventario',
  'signup.plans.professional.features.advanced': 'Reportes Avanzados',
  'signup.plans.professional.features.priority': 'Soporte Prioritario',
  'signup.plans.professional.features.api': 'Acceso API',
  'signup.plans.enterprise.name': 'Empresarial',
  'signup.plans.enterprise.features.everything': 'Todo Incluido',
  'signup.plans.enterprise.features.branches': 'Múltiples Sucursales',
  'signup.plans.enterprise.features.custom': 'Personalización',
  'signup.plans.enterprise.features.dedicated': 'Servidor Dedicado',
  'signup.plans.enterprise.features.training': 'Capacitación',
  'signup.plans.enterprise.features.sla': 'Garantía SLA',
  'signup.popular': 'Más Popular',
  'signup.selectPlan': 'Seleccionar un Plan',
  'signup.billing.monthly': 'Mensual',
  'signup.billing.yearly': 'Anual',
  'signup.billing.save': 'Ahorrar',
  'signup.billing.month': 'mes',
  'signup.billing.billed': 'al año',
  'signup.processing': 'Procesando...',
  'signup.completeSignup': 'Completar Registro',
  'signup.haveAccount': '¿Ya tienes una cuenta?',
  'signup.loginLink': 'Iniciar Sesión',
  'signup.companyCode': 'Código de Empresa',
  'signup.companyCodePlaceholder': 'ej: cleanpro',
  'signup.companyCodeHelp': 'Este código se utilizará para iniciar sesión en el sistema',
  'signup.companyCodeMinLength': 'El código de empresa debe tener al menos 3 caracteres',
  'signup.reservedIds': 'Reservados: demo, admin, test, system',
  'signup.companyName': 'Nombre de Empresa',
  'signup.companyNamePlaceholder': 'Nombre de su Empresa',
  'signup.companyNameRequired': 'El nombre de empresa es requerido',
  'signup.fullName': 'Nombre Completo',
  'signup.fullNamePlaceholder': 'Su Nombre Completo',
  'signup.fullNameRequired': 'El nombre completo es requerido',
  'signup.phone': 'Teléfono',
  'signup.phonePlaceholder': '+34 555 123 4567',
  'signup.validPhoneRequired': 'Por favor ingrese un número de teléfono válido',
  'signup.email': 'Correo Electrónico',
  'signup.emailPlaceholder': 'ejemplo@empresa.com',
  'signup.validEmailRequired': 'Por favor ingrese una dirección de correo electrónico válida',
  'signup.createAccount': 'Crear Cuenta',
  'signup.creating': 'Creando...',
  'signup.terms': 'Al crear una cuenta, acepta nuestros Términos de Servicio y Política de Privacidad.',
  'signup.success': '¡Registro exitoso! Las credenciales de inicio de sesión han sido enviadas a su correo electrónico.',
  'signup.successTitle': '¡Registro Exitoso!',
  'signup.successMessage': 'Su cuenta ha sido creada exitosamente.',
  'signup.emailSent': 'Las credenciales de inicio de sesión han sido enviadas a su correo electrónico.',
  'signup.redirecting': 'Redirigiendo a la página de inicio de sesión...',
  'signup.startupPackageLoaded': '¡Paquete Inicial Cargado!',
  'signup.products': 'Producto',
  'signup.customers': 'Cliente',
  'signup.users': 'Usuario',
  'signup.demoDataReady': '✨ ¡Sus datos de demostración están listos, puede comenzar a usar inmediatamente!',
  'signup.loginInfo': '📧 Sus Credenciales de Acceso',
  'signup.loginInfoSent': '💡 Estas credenciales también han sido enviadas a su correo electrónico',
'signup.loginNow': 'Iniciar Sesión Ahora →',
  'signup.hints.companyCode': 'Se utilizará para iniciar sesión',
  'signup.hints.country': 'Su país fue detectado automáticamente. Puede seleccionar un país diferente.',
  'signup.freeTrial': '🎉 Pruebe gratis durante 15 días - No se requiere tarjeta de crédito!',
  'signup.businessType.question': '¿Qué tipo de negocio tiene?',
  'signup.businessType.hint': 'La pantalla predeterminada se configurará automáticamente según su selección',
  'signup.businessType.continue': 'Continuar',
  'signup.bt.dryCleaning.desc': 'Limpieza de ropa, cortinas y textiles',
  'signup.bt.carpetWashing.desc': 'Lavado de alfombras, kilims y pasillos',
  'signup.bt.shoeShine.desc': 'Limpieza y cuidado de calzado',
  'signup.bt.sofaWashing.desc': 'Lavado de sofás, kanapes y sillones',
  'signup.bt.carWash.desc': 'Lavado, pulido y mantenimiento de vehículos',
  'signup.bt.tailoring.desc': 'Sastrería, arreglos y servicios de costura',
  'signup.bt.barber.desc': 'Peluquería, barbería y salón de belleza',
  'signup.bt.tailoring.desc': 'Sastrería, arreglos y costura',
  'signup.bt.barber.desc': 'Peluquería, barbería y salón de belleza',
  'signup.companyDetails': 'Datos de la Empresa',
  'signup.fields.companyCode': 'Código de Empresa',
  'signup.fields.companyName': 'Nombre de Empresa',
  'signup.fields.ownerName': 'Nombre del Propietario',
  'signup.fields.email': 'Correo Electrónico',
  'signup.fields.phone': 'Teléfono',
  'signup.fields.country': 'País',
  'signup.fields.username': 'Usuario',
  'signup.fields.password': 'Contraseña',
  'signup.fields.confirmPassword': 'Confirmar Contraseña',
  'signup.placeholders.companyCode': 'ej: empresa',
  'signup.placeholders.companyName': 'Nombre de su Empresa',
  'signup.placeholders.ownerName': 'Nombre Completo',
  'signup.placeholders.email': 'ejemplo@empresa.com',
  'signup.placeholders.phone': '+34 555 123 4567',

  // Service Types
  'service.tailor': 'Sastre',
  'service.dryCleaning': 'Limpieza en Seco',
  'service.washing': 'Lavado',
  'service.ironing': 'Plancha',
  'service.dyeing': 'Teñido',
  'service.shoeShine': 'Lustrado de Zapatos',
  'service.carpet': 'Alfombra',
  'service.tailoring': 'Reparación de Sastrería',
  'service.carpetWashing': 'Lavado de Alfombras',
  'service.sofaWashing': 'Lavado de Sofás',
  'service.carWash': 'Lavado de Autos & Detailing',
  'service.barber': 'Barbería / Peluquería',
  'service.selectService': 'Seleccionar Servicio',
  'service.addToCart': 'Agregar al Carrito',
  'service.total': 'Total',
  
  // Order Create Page
  'orderCreate.cart': 'Carrito',
  'orderCreate.totalPieces': 'Total de Piezas',
  'orderCreate.plannedDelivery': 'Entrega Planificada',
  'orderCreate.payment': 'Pago',
  'orderCreate.save': 'Guardar',
  'orderCreate.continue': 'Continuar',
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',

  'orderCreate.allCategories': 'Todos',
  'orderCreate.selectCustomer': 'Seleccionar Cliente',
  'orderCreate.selectCustomerPlaceholder': 'Seleccionar cliente',
  'orderCreate.change': 'Cambiar',
  'orderCreate.select': 'Seleccionar',
  'orderCreate.balance': 'Saldo',
  'orderCreate.searchCustomer': 'Buscar por nombre, teléfono o dirección... (ejemplo: juan+5551234567)',
  'orderCreate.newCustomer': 'Nuevo Cliente',
  'orderCreate.customerName': 'Nombre Apellido',
  'orderCreate.customerPhone': 'Teléfono',
  'orderCreate.customerEmail': 'Correo Electrónico',
  'orderCreate.customerAddress': 'Dirección',
  'orderCreate.addCustomer': 'Agregar Cliente',
  'orderCreate.customer': 'Cliente',
  'orderCreate.serviceType': 'Tipo de Servicio',
  'orderCreate.clickToSelect': 'Clic para seleccionar',
  'orderCreate.deliveryDate': 'Fecha de Entrega',
  'orderCreate.details': 'Detalles',
  'orderCreate.itemDetails': 'Detalles del Artículo',
  'orderCreate.tailoringOperations': 'Operaciones de Sastrería',
  'orderCreate.tailoringTitle': 'Operaciones de Sastrería',
  'orderCreate.discount': 'Descuento',
  'orderCreate.discountLabel': 'Descuento (%)',
  'orderCreate.debt': 'Deuda',
  'orderCreate.credit': 'Crédito',
  'orderCreate.homeDelivery': 'Entrega a Domicilio',
  'orderCreate.pickupFromAddress': 'El conductor recogerá en el domicilio',
  'orderCreate.homeDeliveryAddress': 'Dirección',
  'orderCreate.addressRequired': '¡Dirección requerida!',
  'orderCreate.subtotal': 'Subtotal',
  'orderCreate.grandTotal': 'Total General',
  
  // Products
  'products.title': 'Definiciones de Productos',
  'products.addNew': 'Nuevo Producto',
  'products.category': 'Categoría',
  'products.name': 'Nombre del Producto',
  'products.price': 'Precio',
  'products.color': 'Color',
  'products.active': 'Activo',
  'products.actions': 'Acciones',
  'products.search': 'Buscar Producto...',
  'products.noProducts': 'No se encontraron productos',
  'products.noCategoryProducts': 'No se encontraron productos en esta categoría',
  'products.emptyCart': 'El carrito está vacío',
  
  // Payment
  'payment.method': 'Método de Pago',
  'payment.adjustment': 'Ajuste de saldo',
  'payment.cash': 'Efectivo',
  'payment.creditCard': 'Tarjeta de Crédito (POS)',
  'payment.mealCard': 'Tarjeta de Comida',
  'payment.account': 'Cuenta',
  'payment.onDelivery': 'En Entrega',
  'payment.bankTransfer': 'Transferencia Bancaria',
  'payment.selectMethod': 'Seleccionar método de pago',
  'payment.amount': 'Monto de Pago',
  'payment.amountToPay': 'Monto a Pagar',
  'payment.paid': 'Pagado',
  'payment.remaining': 'Restante',
  'payment.complete': 'Completar Pago',
  'payment.confirm': 'Confirmar Pago',
  'payment.posPayment': 'Pago con Tarjeta de Crédito (Dispositivo POS)',
  'payment.posInstructions': 'Por favor tome el pago del cliente usando el dispositivo POS.',
  'payment.posConfirm': 'Después de recibir la confirmación de pago del dispositivo POS, haga clic en el botón "Confirmar".',
  'payment.success': 'Pago exitoso',
  'payment.failed': 'Pago fallido',
  'payment.splitPayment': 'Pago Dividido',
  'payment.addPayment': 'Agregar Pago',
  'payment.status': 'Estado del Pago',
  'payment.pending': 'Pendiente',
  'payment.completed': 'Completado',
  'payment.partial': 'Pago Parcial',
  
  // Users
  'users.title': 'Usuarios',
  'users.addNew': 'Nuevo Usuario',
  'users.name': 'Nombre Completo',
  'users.email': 'Correo Electrónico',
  'users.role': 'Rol',
  'users.pin': 'PIN',
  'users.permissions': 'Permisos',
  'users.allPermissions': 'Todos los Permisos',
  'users.permissionCount': '{count} permisos',
  'users.changePin': 'Cambiar PIN',
  'users.edit': 'Editar',
  'users.newUser': 'Nuevo Usuario',
  'users.editUser': 'Editar Usuario',
  'users.editingUser': 'Editando usuario {name}',
  'users.pinCode': 'Código PIN (4-6 dígitos)',
  'users.selectRole': 'Seleccionar rol',
  'users.patron': 'Dueño',
  'users.kasiyer': 'Cajero',
  'users.sofor': 'Conductor',
  'users.eleman': 'Empleado',
  'users.changePinTitle': 'Cambiar Código PIN',
  'users.newPin': 'Nuevo Código PIN',
  'users.confirmPin': 'Confirmar Código PIN',
  'users.pinMismatch': 'Los códigos PIN no coinciden',
  'users.pinRequired': 'El código PIN es obligatorio',
  'users.pinLength': 'El código PIN debe tener entre 4 y 6 dígitos',
  'users.changingPinFor': 'Cambiando código PIN para {name}',
  
  // Customers
  'customers.title': 'Clientes',
  'customers.addNew': 'Nuevo Cliente',
  'customers.search': 'Buscar Clientes...',
  'customers.name': 'Nombre',
  'customers.phone': 'Teléfono',
  'customers.email': 'Correo Electrónico',
  'customers.address': 'Dirección',
  'customers.balance': 'Saldo',
  'customers.actions': 'Acciones',
  'customers.edit': 'Editar',
  'customers.delete': 'Eliminar',
  'customers.noCustomers': 'No se encontraron clientes',
  'customers.tableCustomer': 'Cliente',
  'customers.tableContact': 'Contacto',
  'customers.tableAddress': 'Dirección',
  'customers.tableNotifications': 'Notificaciones',
  'customers.tableBalance': 'Saldo',
  'customers.tableActions': 'Acciones',
  'customers.totalCount': 'Total {count} clientes',
  'customers.notes': 'Nota',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Buscar por nombre, teléfono, correo o dirección... (ejemplo: juan+5551234567)',
  'customers.updated': 'Cliente actualizado',
  'customers.updateError': 'Error al actualizar cliente',
  'customers.added': 'Cliente agregado',
  'customers.addError': 'Error al agregar cliente',
  'customers.deleted': 'Cliente eliminado',
  'customers.deleteError': 'Error al eliminar cliente',
  'customers.deleteConfirm': '¿Está seguro de que desea eliminar al cliente "{name}"?',
  'customers.loadError': 'Error al cargar clientes',
  'customers.noResults': 'No se encontraron resultados',
  'customers.showingFirst50': 'Mostrando los primeros 50 resultados',
  'customers.totalResults': 'total',
  
  // Pricing Page
  'pricing.title': 'Definiciones de Precios',
  'pricing.search': 'Buscar Producto...',
  'pricing.product': 'Producto',
  'pricing.dryCleaning': 'Limpieza en Seco',
  'pricing.washing': 'Lavado',
  'pricing.ironing': 'Plancha',
  'pricing.dyeing': 'Teñido',
  'pricing.tailoring': 'Reparación de Sastrería',
  'pricing.shoeShine': 'Lustrado de Zapatos',
  'pricing.action': 'Acción',
  'pricing.save': 'Guardar',
  'pricing.saving': 'Guardando',
  'pricing.pricesSaved': 'Precios guardados',
  'pricing.pricesSaveError': 'Error al guardar precios',
  'pricing.noProducts': 'No se encontraron productos',
  'pricing.loadError': 'Error al cargar productos',
  
  // Tailoring Page
  'tailoring.title': 'Operaciones de Sastrería',
  'tailoring.addNew': 'Nueva Operación',
  
  // Attributes Page
  'attributes.title': 'Atributos de Producto',
  'attributes.colors': 'Colores',
  'attributes.stains': 'Tipos de Manchas',
  'attributes.damages': 'Tipos de Daños',
  'attributes.add': 'Agregar',
  
  // Permissions Page
  'permissions.title': 'Gestión de Permisos',
  'permissions.subtitle': 'Establecer permisos para roles de propietario y cajero',
  'permissions.about': 'Acerca de la Gestión de Permisos',
  'permissions.patronInfo': '<strong>Propietario:</strong> Rol de administrador principal con todos los permisos del sistema.',
  'permissions.cashierInfo': '<strong>Cajero:</strong> Rol de usuario con permisos limitados para operaciones diarias.',
  'permissions.saveSuccess': 'Permisos guardados',
  'permissions.saveError': 'Error al guardar permisos',
  'permissions.patron': 'Propietario',
  'permissions.cashier': 'Cajero',
  'permissions.patronRole': 'Acceso de administrador completo',
  'permissions.cashierRole': 'Acceso de usuario limitado',
  'permissions.activePermissions': 'Permisos Activos:',
  'permissions.selectAllPatron': 'Seleccionar Todo para Propietario',
  'permissions.deselectAllPatron': 'Deseleccionar Todo para Propietario',
  'permissions.selectAllCashier': 'Seleccionar Todo para Cajero',
  'permissions.deselectAllCashier': 'Deseleccionar Todo para Cajero',
  'permissions.saving': 'Guardando...',
  'permissions.permissionList': 'Lista de Permisos',
  'permissions.infoTitle': 'Acerca de la Gestión de Permisos',
  'permissions.infoText1': 'Rol de administrador principal con todos los permisos del sistema.',
  'permissions.infoText2': 'Rol de usuario con permisos limitados para operaciones diarias.',
  'permissions.infoText3': 'Los cambios no tendrán efecto hasta que se guarden.',
  'permissions.infoText4': 'Los permisos se pueden personalizar para cada rol.',
  
  // Driver Dashboard Page
  'driver.title': 'Panel del Conductor',
  'driver.todayRevenue': 'Ingresos de Hoy',
  'driver.totalPieces': 'Piezas Totales',
  'driver.pending': 'Pendiente',
  'driver.ready': 'Listo',
  'driver.pickup': 'Recoger',
  'driver.delivery': 'Entrega',
  
  // Subscription Page
  'subscription.title': 'Planes de Suscripción',
  'subscription.currentPlan': 'Su Plan Actual',
  'subscription.upgradePlan': 'Actualizar',
  'subscription.downgradePlan': 'Reducir',
  'subscription.choosePlan': 'Elegir Plan',
  'subscription.billingCycle': 'Ciclo de Facturación',
  'subscription.monthly': 'Mensual',
  'subscription.yearly': 'Anual',
  'subscription.perMonth': '/mes',
  'subscription.perYear': '/año',
  'subscription.plusVAT': '+ IVA',
  'subscription.save': 'Ahorre {percent}%',
  'subscription.mostPopular': 'Más Popular',
  'subscription.freeTrial': '{months} mes gratis',
  'subscription.featuresIncluded': 'Funciones incluidas:',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Perfecto para pequeñas empresas',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Para empresas en crecimiento',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Soluciones empresariales',
  'subscription.maxReceipts': 'Máximo {count} recibos/mes',
  'subscription.maxUsers': '{count} cuentas de usuario',
  'subscription.whatsappCredits': '🎁 {count} créditos WhatsApp de regalo',
  'subscription.basicReports': 'Informes básicos',
  'subscription.advancedReports': 'Informes avanzados',
  'subscription.customReports': 'Informes personalizados',
  'subscription.whatsappIntegration': 'Integración WhatsApp',
  'subscription.supportTicket': 'Tiempo de respuesta de ticket: {hours} horas',
  'subscription.supportTicketBusiness': 'Tiempo de respuesta de ticket: {hours} horas (horario laboral)',
  'subscription.accountManagement': 'Gestión de cuentas',
  'subscription.driverApp': 'App móvil conductor',
  'subscription.prioritySupport': 'Soporte prioritario',
  'subscription.managerApp': 'App móvil - vista gerente',
  'subscription.paymentTitle': 'Completar Pago',
  'subscription.planSelection': 'Plan Seleccionado',
  'subscription.billingPeriod': 'Período de Facturación',
  'subscription.month': 'mes',
  'subscription.year': 'año',
  'subscription.subtotal': 'Subtotal',
  'subscription.tax': 'IVA ({rate}%)',
  'subscription.total': 'Total',
  'subscription.couponCode': 'Código de Cupón',
  'subscription.applyCoupon': 'Aplicar',
  'subscription.removeCoupon': 'Eliminar',
  'subscription.discount': 'Descuento',
  'subscription.invalidCoupon': 'Código de cupón inválido',
  'subscription.couponVerificationFailed': 'Verificación de cupón falló',
  'subscription.couponRemoved': 'Cupón eliminado',
  'subscription.billingInfo': 'Información de Facturación',
  'subscription.companyName': 'Nombre de Empresa',
  'subscription.companyNamePlaceholder': 'Ingrese nombre de empresa',
  'subscription.taxNumber': 'Número de IVA',
  'subscription.taxNumberPlaceholder': 'Ingrese número de IVA',
  'subscription.phone': 'Teléfono',
  'subscription.phonePlaceholder': 'Ingrese número de teléfono',
  'subscription.address': 'Dirección',
  'subscription.addressPlaceholder': 'Ingrese dirección de facturación',
  'subscription.corporateInvoice': 'Factura Corporativa',
  'subscription.individualInvoice': 'Factura Individual',
  'subscription.paymentMethod': 'Método de Pago',
  'subscription.creditCard': 'Tarjeta de Crédito',
  'subscription.bankTransfer': 'Transferencia Bancaria',
  'subscription.cardNumber': 'Número de Tarjeta',
  'subscription.cardNumberPlaceholder': 'Ingrese número de tarjeta',
  'subscription.expiryDate': 'Fecha de Vencimiento',
  'subscription.cvc': 'CVC',
  'subscription.completePayment': 'Completar Pago',
  'subscription.processing': 'Procesando...',
  'subscription.redirectingToPayment': 'Redirigiendo a la página de pago...',
  'subscription.paymentSuccess': '✅ ¡Pago exitoso! Su suscripción ha sido activada.',
  'subscription.paymentCompleted': '🎉 ¡Pago completado exitosamente!',
  'subscription.paymentCancelled': '❌ Pago cancelado.',
  'subscription.paddleTestCards': '¡Tarjetas de prueba de Paddle impresas en consola! (F12)',
  'subscription.sandboxTestCards': '🎴 TARJETAS DE PRUEBA (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ TARJETAS DE PRUEBA EXITOSAS:',
  'subscription.failedPaymentCards': '❌ TARJETAS DE PRUEBA FALLIDAS:',
  'subscription.invalidCard': '📌 Tarjeta inválida:',
  'subscription.sandboxOnly': '📝 NOTA: ¡Estas tarjetas solo funcionan en entorno Sandbox!',
  'subscription.enterCompanyName': 'Ingrese nombre de empresa',
  'subscription.enterPhone': 'Ingrese número de teléfono',
  'subscription.enterTaxNumber': 'Ingrese número de IVA',
  'subscription.selectPackage': 'Por favor seleccione un paquete',
  'subscription.selectPlan': 'Por favor seleccione un plan',
  'subscription.paddleNotLoaded': 'SDK de Paddle aún no cargado. Por favor recargue la página.',
  'subscription.paymentError': 'Error de pago: ',
  'subscription.paymentCreationFailed': 'No se pudo crear el pago. Por favor revise los registros de consola.',
  'subscription.paddleConfigurationMissing': '⚠️ ¡Falta Configuración de Paddle!',
  'subscription.paddleDashboardRequired': '⚠️ ¡Se Requiere Configuración del Dashboard de Paddle!',
  'subscription.paddleApiNotConfigured': 'Clave API de Paddle no configurada. Por favor contacte a su administrador.',
  'subscription.cancelConfirm': '¿Está seguro que desea cancelar su suscripción? Su servicio continuará hasta el final del período de facturación.',
  'subscription.cancelSuccess': '✅ Suscripción cancelada. Su servicio continuará hasta el final del período de facturación.',
  'subscription.cancelFailed': 'Cancelación falló',
  'subscription.region.turkey': '🇹🇷 Turquía',
  'subscription.region.europe': '🇪🇺 Europa',
  'subscription.region.other': '🌎 Otro',
  'subscription.status': 'Estado',
  'subscription.active': 'Activo',
  'subscription.sandboxMode': '🧪 SANDBOX (Modo de Prueba)',
  'subscription.liveMode': '🚀 LIVE (Producción)',
  'subscription.paddleActive': 'Activo',
  'subscription.paddleConfigured': '✅ Sí',
  'subscription.paddleNotConfigured': '❌ No',
  'subscription.whatsappCreditsTitle': 'Créditos WhatsApp',
  'subscription.whatsappCreditsPackages': 'Paquetes de Créditos',
  'subscription.whatsappCurrentBalance': 'Saldo Actual',
  'subscription.whatsappCreditsAmount': '{count} Créditos',
  'subscription.whatsappPurchaseCredits': 'Comprar Créditos',
  
  // Invoices Page
  'invoices.title': 'Gestión de Facturas',
  'invoices.subtitle': 'Ver y descargar sus facturas de suscripción',
  
  // Common Form Fields
  'common.perPage': 'Por página',
  'common.page': 'Página',
  'common.orders': 'Pedidos',
  'common.previous': 'Anterior',
  'common.next': 'Siguiente',
  'common.pieces': 'piezas',
  'form.color': 'Color',
  'form.stain': 'Mancha',
  'form.damage': 'Daño',
  'form.notes': 'Notas',
  'form.area': 'Área',
  
  // Stain Types
  'stain.blood': 'Sangre',
  'stain.oil': 'Aceite',
  'stain.ink': 'Tinta',
  'stain.teaCoffee': 'Té/Café',
  'stain.fruit': 'Fruta',
  'stain.rust': 'Óxido',
  'stain.paint': 'Pintura',
  'stain.mud': 'Barro',
  'stain.salt': 'Sal',
  'stain.none': 'Ninguno',
  'stain.status': 'Estado de Mancha',
  'stain.multiple': 'Estado de Mancha (Selección múltiple)',
  'stain.other': 'Otro tipo de mancha (Presione Enter para agregar)...',
  
  // Expenses Page
  'expenses.title': 'Entrada de Gastos',
  'expenses.addNew': 'Nuevo Gasto',
  'expenses.total': 'Gastos Totales',
  'expenses.totalToday': 'Gastos Totales de Hoy',
  'expenses.deletePermission': 'ℹ️ La eliminación de gastos solo está autorizada para el rol de propietario.',
  'expenses.description': 'Descripción',
  'expenses.amount': 'Monto',
  'expenses.category': 'Categoría',
  'expenses.noExpenses': 'No hay registros de gastos hoy',
  'expenses.newExpense': 'Nuevo Gasto',
  'expenses.descriptionLabel': 'Descripción *',
  'expenses.amountLabel': 'Monto ($) *',
  'expenses.categoryLabel': 'Categoría *',
  'expenses.categoryPlaceholder': 'Seleccionar categoría...',
  'expenses.deleteTitle': 'Eliminar Gasto',
  'expenses.deleteConfirm': '¿Está seguro de que desea eliminar este gasto?',
  'expenses.descriptionField': 'Descripción:',
  'expenses.categoryField': 'Categoría:',
  'expenses.amountField': 'Monto:',
  'expenses.dateField': 'Fecha:',
  'expenses.cancel': 'Cancelar',
  'expenses.yesDelete': 'Sí, Eliminar',
  'expenses.deleting': 'Eliminando...',
  'expenses.saved': 'Gasto guardado',
  'expenses.saveError': 'Error al guardar gasto',
  'expenses.deleted': 'Gasto eliminado',
  'expenses.deleteError': 'Error al eliminar gasto',
  'expenses.loadError': 'Error al cargar gastos',
  'expenses.dateFilter': 'Filtro de Fecha',
  'expenses.showDateFilter': 'Seleccionar Rango de Fechas',
  'expenses.startDate': 'Fecha de Inicio',
  'expenses.endDate': 'Fecha de Fin',
  'expenses.applyFilter': 'Filtrar',
  'expenses.clearFilter': 'Limpiar',
  'expenses.activeFilter': 'Filtro Activo',
  'expenses.filterApplied': 'Filtro de fecha aplicado',
  'expenses.filterCleared': 'Filtro borrado',
  'expenses.selectBothDates': 'Por favor seleccione ambas fechas de inicio y fin',
  'expenses.canOnlyDeleteToday': 'Solo puede eliminar los gastos que ingresó hoy.',
  'expenses.myBranch': 'Mi sucursal',
  'expenses.noBranchSelected': '— Sin sucursal seleccionada —',
  'expenses.branchSelect': 'Seleccionar sucursal',
  'expenses.excelError': 'No se pudo crear el archivo Excel',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'registros',
  'expenses.categoryBy': 'Por categoría',
  'expenses.allTypes': 'Todos los tipos',
  'expenses.noBranch': 'Sin sucursal',
  'expenses.allBranches': 'Todas las sucursales',
  'expenses.expenseType': 'Tipo de gasto',
  
  // Delivery List Page
  'deliveryList.title': 'Lista de Entregas',
  'deliveryList.search': 'Número de recibo, nombre de cliente o teléfono...',
  'deliveryList.all': 'Todos',
  'deliveryList.pending': 'Pendiente',
  'deliveryList.ready': 'Listo',
  'deliveryList.date': 'Fecha',
  'deliveryList.pieces': 'Piezas',
  'deliveryList.amount': 'Monto',
  'deliveryList.readyButton': 'Listo',
  'deliveryList.receiptButton': 'Recibo',
  'deliveryList.noOrders': 'No se encontraron pedidos',
  'deliveryList.statusUpdated': 'Pedido marcado como listo',
  'deliveryList.statusUpdateError': 'Error al actualizar estado',
  'deliveryList.loadError': 'Error al cargar pedidos',
  'deliveryList.whatsappSending': '📱 Enviando mensaje de WhatsApp...',
  'deliveryList.smsSent': '📨 Mensaje SMS enviado',
  
  // Delivery Page (Pantalla de Entrega)
  'deliveryPage.title': 'Entrega',
  'deliveryPage.search': 'Buscar por número de recibo, nombre, teléfono o dirección...',
  'deliveryPage.pieces': 'Piezas',
  'deliveryPage.amount': 'Monto',
  'deliveryPage.payment': 'Pago',
  'deliveryPage.deliverButton': 'Entregar',
  'deliveryPage.noOrdersFound': 'No se encontraron pedidos listos',
  'deliveryPage.noReadyOrders': 'No hay pedidos listos para entrega',
  'deliveryPage.minSearchLength': 'Ingrese al menos 3 caracteres para buscar',
  'deliveryPage.paymentDialogTitle': 'Pago contra Entrega',
  'deliveryPage.ordersLoadError': 'Error al cargar pedidos',
  'deliveryPage.searchError': 'Error en la búsqueda',
  'deliveryPage.deliverySuccess': 'Pedido entregado exitosamente',
  'deliveryPage.deliveryError': 'Error en la entrega',
  'deliveryPage.whatsappSending': '📱 Enviando recibo por WhatsApp...',
  'deliveryPage.statusNotReady': 'Pedido encontrado pero no está listo para entrega',
  'deliveryPage.statusPending': 'Pendiente - Por favor marque como listo desde la página "Lista de Entregas" primero',
  'deliveryPage.statusDelivered': 'Entregado',
  'deliveryPage.statusCancelled': 'Cancelado',
  'deliveryPage.receiptDelivered': '✅ *ENTREGADO*',
  'deliveryPage.showItems': 'Mostrar Productos',
  'deliveryPage.itemsList': 'Detalles del Pedido',
  'deliveryPage.unknownProduct': 'Producto Desconocido',
  
  // Delivery
  'delivery.title': 'Gestión de Entregas',
  'delivery.pending': 'Pendiente',
  'delivery.ready': 'Listo',
  'delivery.delivered': 'Entregado',
  'delivery.orderNumber': 'Nº de Pedido',
  'delivery.customer': 'Cliente',
  'delivery.items': 'Productos',
  'delivery.total': 'Total',
  'delivery.deliveryDate': 'Fecha de Entrega',
  'delivery.status': 'Estado',
  'delivery.actions': 'Acciones',
  'delivery.markReady': 'Marcar como Listo',
  'delivery.markDelivered': 'Marcar como Entregado',
  'delivery.printReceipt': 'Imprimir Recibo',
  
  // Notifications
  'notifications.title': 'Notificaciones SMS/WhatsApp',
  'notifications.subtitle': 'Editar configuración de notificaciones SMS y WhatsApp',
  
  // Profile
  'profile.subscriptionBilling': 'Suscripción y Facturación',
  
  // Confirm Delete
  'confirmDelete': '¿Está seguro de que desea eliminar?',
  
  // Receipt Page
  'receipt.title': 'Recibo y Etiqueta',
  'receipt.customerReceipt': 'Recibo del Cliente',
  'receipt.back': 'Volver',
  'receipt.print': 'Imprimir Recibo',
  'receipt.whatsappSend': 'Enviar WhatsApp',
  'receipt.receiptNumber': 'Nº de Recibo',
  'receipt.date': 'Fecha',
  'receipt.time': 'Hora',
  'receipt.product': 'Producto',
  'receipt.quantity': 'Cant.',
  'receipt.price': 'Precio',
  'receipt.totalPieces': 'Total de Piezas',
  'receipt.subtotal': 'Subtotal',
  'receipt.tax': 'IVA',
  'receipt.total': 'TOTAL',
  'receipt.payment': 'Pago',
  'receipt.plannedDelivery': 'Entrega Planificada',
  'receipt.notFound': 'Recibo no encontrado',
  'receipt.newOrder': 'Nuevo Pedido',
  'receipt.search': 'Buscar y Reimprimir Recibo',
  'receipt.searchPlaceholder': 'Buscar por número de recibo, nombre de cliente o teléfono...',
  'receipt.searchEmpty': 'Ingrese número de recibo o nombre de cliente para buscar',
  'receipt.noResults': 'No se encontraron resultados',
  'receipt.resultsCount': '{count} resultados encontrados',
  'receipt.printButton': 'Imprimir Recibo',
  'receipt.products': 'productos',
  'receipt.loadError': 'Error al cargar datos',
  'receipt.whatsappOpening': 'Abriendo WhatsApp...',
  'receipt.labelPrinting': 'Imprimiendo etiqueta {current}/{total}...',
  'receipt.andLabel': 'y Etiqueta',
  'receipt.stain': 'Mancha',
  'receipt.damage': 'Daño',
  'receipt.taxPercent': 'IVA (20%)',
  
  // Account Statement Page (Cari Hesap Ekstresi)
  'accountStatement.title': 'Estado de Cuenta',
  'accountStatement.subtitle': 'Seguimiento de cuentas por cobrar por cliente',
  'accountStatement.selectCustomer': 'Seleccionar Cliente',
  'accountStatement.customerPlaceholder': 'Seleccione un cliente...',
  'accountStatement.searchCustomer': 'Buscar por nombre, teléfono o dirección...',
  'accountStatement.noCustomerSelected': 'Por favor seleccione un cliente',
  'accountStatement.currentBalance': 'Saldo Actual',
  'accountStatement.totalDebt': 'Deuda Total',
  'accountStatement.totalPayments': 'Pagos Totales',
  'accountStatement.transactions': 'Transacciones',
  'accountStatement.noTransactions': 'No se encontraron registros de transacciones para este cliente',
  'accountStatement.date': 'Fecha',
  'accountStatement.description': 'Descripción',
  'accountStatement.debit': 'Débito',
  'accountStatement.credit': 'Crédito',
  'accountStatement.balance': 'Saldo',
  'accountStatement.order': 'Pedido',
  'accountStatement.payment': 'Pago',
  'accountStatement.loadError': 'Error al cargar el estado de cuenta',
  'accountStatement.addPayment': 'Agregar Pago',
  'accountStatement.paymentAmount': 'Monto del Pago',
  'accountStatement.paymentMethod': 'Método de Pago',
  'accountStatement.paymentNotes': 'Notas (Opcional)',
  'accountStatement.recordPayment': 'Registrar Pago',
  'accountStatement.paymentSaved': 'Pago registrado',
  'accountStatement.paymentError': 'Error al registrar el pago',
  'accountStatement.selectCustomerFirst': 'Por favor seleccione primero un cliente',
  'accountStatement.exportStatement': 'Exportar Estado',
  'accountStatement.exportStatementPDF': 'Descargar PDF',
  'accountStatement.noCustomersFound': 'No se encontraron clientes',
  'accountStatement.searchHint': 'Ingrese al menos 2 caracteres para buscar clientes',
  'accountStatement.selectedCustomer': 'Cliente Seleccionado',
  'accountStatement.changeCustomer': 'Cambiar Cliente',
  
  // Toast Messages
  'toast.usernameRequired': 'Se requiere nombre de usuario',
  'toast.firstLoginChangePin': '⚠️ Primer inicio de sesión - Por favor cambie su código PIN',
  'toast.tenantNotFound': 'Empresa no encontrada: "{tenantId}"\\n\\nPor favor haga clic en "Iniciar Prueba Gratuita" para crear una nueva cuenta de empresa.',
  'toast.tenantIdNotRemembered': '🗑️ El ID de empresa no será recordado',
  'toast.demoDataLoaded': '¡Se crearon usuarios de demostración, productos, clientes y pedidos!',
  
  'toast.productsLoadError': 'Error al cargar productos',
  'toast.statsLoadError': 'Error al cargar estadísticas',
  'toast.deliveryBeforeToday': 'La fecha de entrega no puede ser anterior a hoy',
  'toast.customerOpenOrders': 'El cliente tiene {count} pedidos abiertos',
  'toast.customerDebt': 'El cliente tiene una deuda de {amount}',
  'toast.customerSaved': 'Cliente guardado',
  'toast.customerSaveError': 'Error al guardar cliente',
  'toast.customerUpdated': 'Cliente actualizado',
  'toast.customerUpdateError': 'Error al actualizar cliente',
  'toast.productAddedToCart': 'Producto agregado al carrito',
  'toast.enterValidArea': 'Por favor ingrese un área válida',
  'toast.carpetsAddedToCart': '{count} alfombras agregadas al carrito ({area} m² x {price}/m²)',
  'toast.carpetAddedToCart': 'Alfombra agregada al carrito ({area} m² x {price}/m²)',
  'toast.selectAtLeastOneService': 'Por favor seleccione al menos un servicio',
  'toast.productAdded': 'Producto agregado',
  'toast.productDetailsUpdated': 'Detalles del producto actualizados',
  'toast.priceUpdated': 'Precio actualizado',
  'toast.fillAllCardInfo': 'Por favor complete toda la información de la tarjeta',
  'toast.invalidCardNumber': 'Número de tarjeta inválido',
  'toast.invalidMonth': 'Mes inválido (debe estar entre 1-12)',
  'toast.invalidYear': 'Año inválido',
  'toast.invalidCvc': 'CVC inválido',
  'toast.cardPaymentSuccess': '¡Pago con tarjeta exitoso!',
  'toast.cardPaymentError': 'Error en el pago con tarjeta',
  'toast.paymentFailed': 'Pago fallido. Por favor intente nuevamente.',
  'toast.paymentStatusCheckError': 'Error al verificar el estado del pago. Por favor revise su cuenta.',
  'toast.selectCustomer': 'Por favor seleccione un cliente',
  'toast.addProduct': 'Por favor agregue un producto',
  'toast.addressRequiredForDelivery': 'Se requiere dirección del cliente para entrega a domicilio. Por favor agregue una dirección.',
  'toast.orderSaved': 'Pedido guardado',
  'toast.orderSaveError': 'Error al guardar pedido',
  'toast.enterValidValue': 'Ingrese un valor válido (0-100)',
  'toast.enterValidAmount': 'Ingrese un monto válido',
  'toast.amountExceedsRemaining': 'El monto no puede exceder el saldo restante',
  'toast.selectPaymentMethodFirst': 'Seleccione primero un método de pago e ingrese el monto',
  'toast.selectAtLeastOneOperation': 'Por favor seleccione al menos una operación',
  'toast.tailorAddedToCart': 'Operación de sastrería agregada al carrito',
  
  'toast.receiptCopied': '📋 ¡Recibo copiado! Seleccione un contacto en WhatsApp Web y pegue (Ctrl+V)',
  'toast.autoCopyFailed': '⚠️ Copia automática fallida. Por favor copie manualmente desde la vista previa.',
  'toast.printingLabel': 'Imprimiendo etiqueta {current}/{total}...',
  'toast.markedAsReady': '✅ Pedido marcado como listo',
  'toast.messageCopied': '📋 ¡Mensaje copiado! Pegue en WhatsApp (Ctrl+V)',
  'toast.whatsappSending': 'Enviando mensaje de WhatsApp...',
  'toast.readyMarkError': 'Error al marcar como listo',
  'toast.markedAsDelivered': '✅ Pedido marcado como entregado',
  'toast.deliveredMarkError': 'Error al marcar como entregado',
  'toast.copyFailed': '⚠️ Copia fallida. Seleccione el texto y presione Ctrl+C',
  'toast.textSelected': '✅ ¡Texto seleccionado! Copie con Ctrl+C',
  'toast.textSelectFailed': 'No se pudo seleccionar el texto',
  'toast.statusUpdated': 'Estado actualizado',
  'toast.smsSent': 'SMS enviado',
  'toast.statusUpdateError': 'Error al actualizar estado',
  'toast.cancelReasonRequired': 'Se requiere motivo de cancelación',
  'toast.orderCancelled': 'Pedido cancelado',
  'toast.cancelError': 'Error al cancelar',
  'toast.deliverySuccess': 'Entrega exitosa',
  'toast.deliveryError': 'Error en la entrega',
  'toast.orderSetToReady': 'Pedido marcado como listo',
  
  'toast.tenantIdNotFound': 'ID de tenant no encontrado',
  'toast.demoProductsLoaded': '¡Productos de demostración cargados!',
  'toast.productsAddError': 'Error al agregar productos',
  'toast.orderDetailsLoadError': 'Error al cargar detalles del pedido',
  'toast.orderLoadError': 'Error al cargar pedido',
  'toast.customerExistingSelected': 'Cliente existente seleccionado',
  'toast.paymentFailedTryAgain': 'Pago fallido. Por favor intente nuevamente.',
  'toast.paymentStatusCheckFailed': 'No se pudo verificar el estado del pago.',
  'toast.customerPhoneNotFound': 'No se encontró el teléfono del cliente',
  'toast.whatsappSent': '¡Mensaje de WhatsApp enviado! ✅',
  'toast.whatsappFailed': 'No se pudo enviar el mensaje de WhatsApp',
  'toast.orderUpdateError': 'Error al actualizar el pedido',
  'toast.searchError': 'Error de búsqueda',
  'toast.orderNotFound': 'Pedido no encontrado',
  'toast.editCancelled': 'Edición cancelada',
  'toast.noEditPermission': 'No tiene permiso para editar pedidos pasados',
  'toast.englishNamesMigration': 'Nombres en inglés agregados a {count} productos',
  'toast.migrationFailed': 'Migración fallida',
  'toast.multiLanguageConversion': '✅ ¡{count} productos convertidos a formato multiidioma!',
  'toast.multiLanguageConversionError': 'Error en la conversión multiidioma',
  'toast.productNameRequired': 'Se requiere nombre del producto',
  'toast.productUpdated': 'Producto actualizado',
  'toast.productDeleted': 'Producto eliminado',
  'toast.productDeleteError': 'Error al eliminar producto',
  
  // Z-Report
  'zReport.singleDay': 'Día único',
  'zReport.dateRange': 'Rango de fechas',
  'zReport.startDate': 'Fecha de inicio',
  'zReport.endDate': 'Fecha de fin',
  'zReport.totalOrders': 'Total pedidos',
  'zReport.cancelledOrders': 'Pedidos cancelados',
  'zReport.totalRevenue': 'Ingresos totales',
  'zReport.paymentMethods': 'Métodos de pago',
  'zReport.cash': 'Efectivo',
  'zReport.creditCard': 'Tarjeta de crédito',
  'zReport.account': 'Cuenta',
  'zReport.free': 'Gratuito',
  'zReport.paidAtRegister': 'Pagado al registro',
  'zReport.paidAtDelivery': 'Pagado ala entrega',
  'zReport.collectionDetails': 'Detalles de cobro',
  'zReport.incoming': 'Entrante',
  'zReport.outgoing': 'Saliente',
  'zReport.totalRegistered': 'Total registrado',
  'zReport.expenses': 'Gastos',
  'zReport.noExpenses': 'Sin gastos',
  'zReport.totalExpenses': 'Total gastos',
  'zReport.cancelledReceipts': 'Recibos cancelados',
  'zReport.reason': 'Motivo',
  'zReport.noCancelled': 'Sin recibos cancelados',
  'zReport.totalCancelled': '{count} recibos cancelados',
  'zReport.serviceBreakdown': 'Desglose por servicio',
  'zReport.loadError': 'Informe Z no cargado',
  'zReport.excelError': 'Error al descargar Excel',
  'zReport.excelDownloaded': 'Excel descargado',
  'zReport.loading': 'Cargando...',
  'zReport.todayOrders': 'Pedidos de hoy',
  'zReport.registrationAndDelivery': 'Registro + Entrega',
  'zReport.orderPaidAtRegister': 'Pedido pagado al registro',
  'zReport.orderPaidAtDelivery': 'Pedido pagado ala entrega',
  'zReport.accountCollections': 'Cobros cuenta',
  'zReport.totalCollection': 'Total cobrado',
  'zReport.bankTransfer': 'Transferencia bancaria',
  'zReport.cashRegister': 'Caja',
  'zReport.startingCash': 'Efectivo inicial',
  'zReport.dailyCashIncome': 'Ingreso cash de hoy',
  'zReport.cashToDeliver': 'Cash a entregar',
  'zReport.cashCalculation': '(Inicio + Cash de hoy - Gastos)',

  // Claves comunes faltantes
  'common.allYears': 'Todos los años',
  'common.autoDetected': 'Detectado automáticamente',
  'common.cancelled': 'Cancelado',
  'common.clear': 'Limpiar',
  'common.export': 'Exportar',
  'common.exportExcel': 'Descargar Excel',
  'common.exportToExcel': 'Exportar a Excel',
  'common.filter': 'Filtrar',
  'common.items': 'Artículos',
  'common.loadError': 'No se pudo cargar',
  'common.none': 'Ninguno',
  'common.ok': 'OK',
  'common.paid': 'Pagado',
  'common.print': 'Imprimir',
  'common.printDate': 'Fecha de impresión',
  'common.searchError': 'Error de búsqueda',
  'common.searchResults': '(Resultados de búsqueda)',
  'common.unit': 'Unidad',
  'common.year': 'Año',

  // Estado de cuenta
  'accountStatement.allTime': 'Todo el tiempo',
  'accountStatement.customer': 'Cliente',
  'accountStatement.customerReceipts': 'Recibos del cliente',
  'accountStatement.noData': 'No se encontraron estados de cuenta',
  'accountStatement.noReceipts': 'No se encontraron recibos',
  'accountStatement.payments': 'Pagos',
  'accountStatement.period': 'Período',
  'accountStatement.printStatement': 'Imprimir estado de cuenta',
  'accountStatement.receipts': 'Recibos',
  'accountStatement.remaining': 'Saldo pendiente',
  'accountStatement.statement': 'Estado de cuenta',
  'accountStatement.totalPaid': 'Total pagado',

  // Anuncio
  'announcement.trialInfo': 'Período de prueba activo',
  'announcement.welcome': 'Bienvenido',

  // Atributos
  'attributes.addColor': 'Agregar color',
  'attributes.addDamage': 'Agregar daño',
  'attributes.addError': 'No se pudo agregar',
  'attributes.addStain': 'Agregar mancha',
  'attributes.color': 'Color',
  'attributes.deleteError': 'No se pudo eliminar el atributo',
  'attributes.deleted': 'Atributo eliminado',
  'attributes.loadError': 'No se pudieron cargar los atributos',
  'attributes.name': 'Nombre del atributo',
  'attributes.noAttributes': 'No hay atributos definidos',
  'attributes.save': 'Guardar',
  'attributes.saveError': 'No se pudieron guardar los atributos',
  'attributes.saved': 'Atributos guardados',
  'attributes.updateError': 'No se pudo actualizar',
  'attributes.value': 'Valor',

  // Estado del cliente
  'customerStatement.receiptDelivered': 'Entregado',
  'customerStatement.receiptOpen': 'Abierto',

  // Clientes
  'customers.add': 'Agregar cliente',
  'customers.adres': 'Dirección',
  'customers.cannotDeleteWithOrders': 'No se puede eliminar un cliente con pedidos',
  'customers.import': 'Importar',
  'customers.importTitle': 'Importar clientes',
  'customers.legacyHidden': 'Oculto (Antiguo)',
  'customers.notFound': 'Cliente no encontrado',
  'customers.phoneMissing': 'Número de teléfono faltante',
  'customers.telefon': 'Teléfono',
  'customers.telefon2': 'Teléfono 2',

  // Daños
  'damage.add': 'Agregar daño',
  'damage.description': 'Descripción',
  'damage.location': 'Ubicación',
  'damage.noPhoto': 'Sin foto',
  'damage.photo': 'Foto',
  'damage.saveError': 'No se pudo guardar el informe de daño',
  'damage.saved': 'Informe de daño guardado',
  'damage.severity': 'Gravedad',
  'damage.title': 'Informe de daño',
  'damage.type': 'Tipo de daño',

  // Tablero
  'dashboard.allTime': 'Todo el tiempo',

  // Entrega
  'delivery.complete': 'Entregar',
  'delivery.deliveredItems': 'Artículos entregados',
  'delivery.deliveredProducts': 'Productos entregados',
  'delivery.error': 'Error de entrega',
  'delivery.loadError': 'No se pudo cargar',
  'delivery.noOrders': 'No se encontraron pedidos',
  'delivery.orderDelivered': 'Pedido entregado',
  'delivery.orderReady': 'Pedido listo',
  'delivery.searchOrder': 'Buscar pedido',
  'delivery.success': 'Entrega exitosa',
  'delivery.updateError': 'No se pudo actualizar',

  // Lista de entregas
  'deliveryList.address': 'Dirección',
  'deliveryList.cancelButton': 'Cancelar',
  'deliveryList.cancelConfirm': 'Confirmar cancelación',
  'deliveryList.cancelReasonPlaceholder': 'Motivo de cancelación...',
  'deliveryList.cancelTitle': 'Cancelar pedido',
  'deliveryList.complete': 'Completar',
  'deliveryList.completed': 'Completado',
  'deliveryList.delivered': 'Entregado',
  'deliveryList.deliveryError': 'Error de entrega',
  'deliveryList.driver': 'Conductor',
  'deliveryList.items': 'Artículos',
  'deliveryList.messageError': 'Error de mensaje',
  'deliveryList.orderCancelled': 'Pedido cancelado',
  'deliveryList.orderDelivered': 'Pedido entregado',
  'deliveryList.pending': 'Pendiente',
  'deliveryList.phone': 'Teléfono',
  'deliveryList.selectDriver': 'Seleccionar conductor',
  'deliveryList.status': 'Estado',
  'deliveryList.title': 'Lista de entregas',
  'deliveryList.whatsappError': 'Error de WhatsApp',
  'deliveryList.whatsappSent': 'WhatsApp enviado',

  // Página de entrega
  'deliveryPage.changeDeliveryType': 'Cambiar tipo de entrega',
  'deliveryPage.changeToDelivery': 'Cambiar a entrega',
  'deliveryPage.changeToDeliverySuccess': 'Cambiado a entrega',
  'deliveryPage.changeToPickup': 'Cambiar a recogida',
  'deliveryPage.changeToPickupError': 'No se pudo cambiar',
  'deliveryPage.changeToPickupSuccess': 'Cambiado a recogida',
  'deliveryPage.searchAll': 'Todos',
  'deliveryPage.searchBy': 'Buscar por',
  'deliveryPage.searchName': 'Nombre del cliente',
  'deliveryPage.searchNamePlaceholder': 'Ingrese el nombre...',
  'deliveryPage.searchPhone': 'Teléfono',
  'deliveryPage.searchPhoneBtn': 'Buscar por teléfono',
  'deliveryPage.searchPlaceholder': 'Buscar...',
  'deliveryPage.searchReceipt': 'N° recibo',
  'deliveryPage.searchReceiptPlaceholder': 'Ingrese el n° recibo...',

  // Error
  'errorBoundary.unauthorized': 'No autorizado',
  'errorBoundary.unauthorizedDetails': 'No tiene permiso para acceder a esta página',
  'errorBoundary.unknownError': 'Error desconocido',

  // Conductor
  'driver.searchHint': 'Ingrese al menos 2 caracteres',
  'driver.searchPlaceholder': 'N° recibo, nombre o teléfono...',

  // Pie de página
  'footer.euServers': 'Servidores UE',
  'footer.gdpr': 'Conforme con RGPD',

  // Facturas
  'invoices.downloading': 'Descargando...',

  // Inicio de sesión
  'login': 'Iniciar sesión',
  'login.credentialsTitle': 'Credenciales',
  'login.demoAccount': 'Cuenta demo',
  'login.demoCredentials': 'Credenciales demo',
  'login.demoLoaded': 'Demo cargado',
  'login.enterCredentials': 'Ingrese las credenciales',
  'login.firstLoginChangePin': 'Cambie su PIN en el primer inicio de sesión',
  'login.forget': '¿Olvidó su contraseña?',
  'login.invalidCredentials': 'Credenciales inválidas',
  'login.legalText': 'Texto legal',
  'login.pin': 'PIN',
  'login.pinDescription': 'Ingrese su PIN de 4 dígitos',
  'login.pinRequired': 'PIN requerido',
  'login.rememberMe': 'Recordarme',
  'login.saveCredentialsNote': 'Credenciales guardadas de forma segura',
  'login.signIn': 'Iniciar sesión',
  'login.signingIn': 'Iniciando sesión...',
  'login.tagline': 'Software de limpieza en seco — Soluciones inteligentes para su negocio.',
  'login.tenantIdNotRemembered': 'ID de empresa no recordado',
  'login.tenantRequired': 'ID de empresa requerido',
  'login.tryForFree': 'Probar gratis',
  'login.username': 'Nombre de usuario',
  'login.usernamePlaceholder': 'Ingrese el nombre de usuario...',
  'login.usernameRequired': 'Nombre de usuario requerido',
  'login.version': 'Versión',
  'logout': 'Cerrar sesión',

  // Menú
  'menu.driverPickup': 'Recogida por conductor',
  'menu.hardware': 'Hardware',
  'menu.payment': 'Pago',
  'menu.reportsCharts': 'Informes y gráficos',

  // Navegación
  'nav.logout': 'Cerrar sesión',
  'nav.user': 'Usuario',

  // Notificaciones
  'notifications': 'Notificaciones',
  'notifications.customMessage': 'Mensaje personalizado',
  'notifications.failure': 'Error al enviar notificación',
  'notifications.message': 'Mensaje',
  'notifications.preview': 'Vista previa',
  'notifications.schedule': 'Programar',
  'notifications.scheduleLater': 'Programar para después',
  'notifications.selectCustomer': 'Seleccionar cliente',
  'notifications.selectDateTime': 'Seleccionar fecha y hora',
  'notifications.selectTemplate': 'Seleccionar plantilla',
  'notifications.send': 'Enviar',
  'notifications.sendError': 'Error al enviar',
  'notifications.sendNow': 'Enviar ahora',
  'notifications.sending': 'Enviando...',
  'notifications.sent': 'Enviado',
  'notifications.sms': 'SMS',
  'notifications.success': 'Notificación enviada',
  'notifications.whatsapp': 'WhatsApp',

  // Pedido
  'order.addProduct': 'Agregar producto',
  'order.amount': 'Importe',
  'order.customer': 'Cliente',
  'order.discount': 'Descuento',
  'order.grandTotal': 'Total general',
  'order.homeDelivery': 'Entrega a domicilio',
  'order.newCustomer': 'Nuevo cliente',
  'order.price': 'Precio',
  'order.processing': 'Procesando...',
  'order.products': 'Productos',
  'order.quantity': 'Cantidad',
  'order.selectCustomer': 'Seleccionar cliente',
  'order.selectProduct': 'Seleccionar producto',
  'order.subtotal': 'Subtotal',
  'order.tax': 'Impuesto',
  'order.title': 'Pedido',
  'order.total': 'Total',
  'orderCreate.selectOperation': 'Seleccionar operación',
  'orderCreate.selectedOperations': 'Operaciones seleccionadas',

  // Pago
  'payment.bank': 'Transferencia bancaria',
  'payment.collect': 'Cobrar',
  'payment.credit': 'Crédito',
  'payment.free': 'Gratis',
  'payment.paymentCare': 'Pago de cuenta',
  'payment.paymentsSaved': 'Pagos guardados',
  'payment.saveError': 'No se pudieron guardar los pagos',
  'payment.saved': 'Pago guardado',
  'payment.split': 'Pago dividido',

  // Marcadores de posición
  'placeholder.customerAddress': 'Ingrese la dirección...',
  'placeholder.customerEmail': 'Ingrese el correo...',
  'placeholder.customerName': 'Ingrese el nombre...',
  'placeholder.customerNotes': 'Ingrese las notas...',
  'placeholder.customerPhone': 'Ingrese el teléfono...',

  // Precios
  'pricing.amount': 'Importe',
  'pricing.enterPrice': 'Ingrese el precio',
  'pricing.percent': 'Porcentaje',

  // Producto
  'product.damage': 'Daño',
  'product.stain': 'Mancha',

  // Productos
  'products.addError': 'No se pudo agregar el producto',
  'products.allCategories': 'Todas las categorías',
  'products.delete': 'Eliminar',
  'products.deleteConfirm': 'Confirmar eliminación',
  'products.deleteError': 'No se pudo eliminar',
  'products.deleting': 'Eliminando...',
  'products.editProduct': 'Editar producto',
  'products.loadError': 'No se pudieron cargar los productos',
  'products.newProduct': 'Nuevo producto',
  'products.pieceCount': 'Cantidad de piezas',
  'products.productActive': 'Activo',
  'products.productAdded': 'Producto agregado',
  'products.productCategory': 'Categoría',
  'products.productDeleted': 'Producto eliminado',
  'products.productInActive': 'Inactivo',
  'products.productName': 'Nombre del producto',
  'products.productPrice': 'Precio',
  'products.productUpdated': 'Producto actualizado',
  'products.save': 'Guardar',
  'products.saveError': 'No se pudo guardar',
  'products.saved': 'Guardado',
  'products.saving': 'Guardando...',
  'products.searchProduct': 'Buscar producto',
  'products.updateError': 'No se pudo actualizar',
  'products.updatePrice': 'Actualizar precio',
  'products.updatePrices': 'Actualizar precios',

  // Perfil
  'profile.changePassword': 'Cambiar contraseña',
  'profile.confirmPassword': 'Confirmar contraseña',
  'profile.currentPassword': 'Contraseña actual',
  'profile.email': 'Correo electrónico',
  'profile.name': 'Nombre',
  'profile.newPassword': 'Nueva contraseña',
  'profile.passwordChangeError': 'No se pudo cambiar la contraseña',
  'profile.passwordChanged': 'Contraseña cambiada',
  'profile.passwordMismatch': 'Las contraseñas no coinciden',
  'profile.phone': 'Teléfono',
  'profile.role': 'Rol',
  'profile.save': 'Guardar',
  'profile.saveError': 'No se pudo guardar',
  'profile.saved': 'Guardado',
  'profile.saving': 'Guardando...',
  'profile.title': 'Perfil',

  // Recibo
  'receipt.addressLabel': 'Dirección',
  'receipt.allYears': 'Todos los años',
  'receipt.area': 'Área',
  'receipt.backButton': 'Volver',
  'receipt.buyCredits': 'Comprar créditos',
  'receipt.cancelled': 'Cancelado',
  'receipt.cancelledBanner': 'Este pedido ha sido cancelado',
  'receipt.cancelledBy': 'Cancelado por',
  'receipt.cancelledDate': 'Fecha de cancelación',
  'receipt.cancelledReason': 'Motivo de cancelación',
  'receipt.card': 'Tarjeta',
  'receipt.cash': 'Efectivo',
  'receipt.change': 'Cambio',
  'receipt.connect': 'Conectar',
  'receipt.connected': 'Conectado',
  'receipt.copyButton': 'Copiar',
  'receipt.copySend': 'Copiar y enviar',
  'receipt.copyTip': 'Copiar mensaje',
  'receipt.creditsFinished': '¡Créditos de WhatsApp agotados!',
  'receipt.customer': 'Cliente',
  'receipt.customerInfo': 'Info del cliente',
  'receipt.customerName': 'Nombre del cliente',
  'receipt.deliveryDate': 'Fecha de entrega',
  'receipt.discount': 'Descuento',
  'receipt.discountedTotal': 'Total con descuento',
  'receipt.footerNote': 'Nota al pie',
  'receipt.freeOfCharge': 'Gratuito',
  'receipt.generalTotal': 'Total general',
  'receipt.goToWhatsAppPage': '¿Ir a la página de WhatsApp?',
  'receipt.grandTotal': 'Total final',
  'receipt.homeDelivery': 'Entrega a domicilio',
  'receipt.invalid': 'Recibo inválido',
  'receipt.items': 'Artículos',
  'receipt.label': 'Etiqueta',
  'receipt.labelPrinted': 'Etiqueta impresa',
  'receipt.markAsDelivered': 'Marcar como entregado',
  'receipt.markAsReady': 'Marcar como listo',
  'receipt.markDeliveredError': 'Error al marcar como entregado',
  'receipt.markReadyError': 'Error al marcar como listo',
  'receipt.messageFailed': 'No se pudo enviar el mensaje',
  'receipt.messageSendFailed': 'El envío del mensaje falló',
  'receipt.messageSent': '¡Mensaje enviado!',
  'receipt.new': 'Nuevo recibo',
  'receipt.noCollection': 'Sin colección',
  'receipt.noReceiptFound': 'No se encontró el recibo',
  'receipt.notes': 'Notas',
  'receipt.onlyProEnterprise': 'Solo Pro/Enterprise',
  'receipt.openWhatsApp': 'Abrir WhatsApp',
  'receipt.orderMarkedDelivered': 'Pedido marcado como entregado',
  'receipt.orderMarkedReady': 'Pedido marcado como listo',
  'receipt.orderNumber': 'Número de pedido',
  'receipt.orderReceived': 'Pedido recibido',
  'receipt.paid': 'Pagado',
  'receipt.partialPayment': 'Pago parcial',
  'receipt.paymentMethod': 'Método de pago',
  'receipt.phone': 'Teléfono',
  'receipt.phoneNotFound': 'Número de teléfono no encontrado',
  'receipt.piece': 'Pieza',
  'receipt.preview': 'Vista previa',
  'receipt.printError': 'Error de impresión',
  'receipt.printerConnectError': 'No se pudo conectar la impresora',
  'receipt.productsInfo': 'Productos',
  'receipt.receiptInfo': 'Información del recibo',
  'receipt.remaining': 'Saldo pendiente',
  'receipt.remainingCredits': 'Créditos restantes',
  'receipt.reprint': 'Reimprimir',
  'receipt.scanQR': 'Escanear código QR',
  'receipt.searchAll': 'Todos',
  'receipt.searchBy': 'Buscar por',
  'receipt.searchError': 'Error de búsqueda',
  'receipt.searchName': 'Nombre del cliente',
  'receipt.searchPhone': 'Teléfono',
  'receipt.searchReceipt': 'N° recibo',
  'receipt.searchReceiptPlaceholder': 'Ingrese el n° recibo...',
  'receipt.searchTitle': 'Buscar recibo',
  'receipt.selectAll': 'Seleccionar todo',
  'receipt.serviceSummary': 'Resumen de servicios',
  'receipt.sessionNotFound': 'Sesión no encontrada. Por favor inicie sesión nuevamente.',
  'receipt.status': 'Estado',
  'receipt.thankYou': 'Gracias',
  'receipt.thermalPrinter': 'Impresora térmica',
  'receipt.thisReceiptCancelled': 'Este recibo ha sido cancelado',
  'receipt.unknownError': 'Error desconocido',
  'receipt.whatsappFeature': 'Función WhatsApp',
  'receipt.whatsappNotConnected': '¡WhatsApp no conectado!',
  'receipt.whatsappPreview': 'Vista previa de WhatsApp',
  'receipt.whatsappPreviewDesc': 'Vista previa del mensaje',
  'receipt.whatsappPreviewTitle': 'Vista previa',
  'receipt.year': 'Año',

  // Informes
  'reports.averageOrder': 'Pedido promedio',
  'reports.dateRange': 'Rango de fechas',
  'reports.ordersCount': 'Número de pedidos',
  'reports.salesReport': 'Informe de ventas',
  'reports.totalSales': 'Ventas totales',

  // Lista de informes
  'reportsList.activeOnly': 'Solo activos',
  'reportsList.amount': 'Importe',
  'reportsList.cancelled': 'Cancelado',
  'reportsList.customer': 'Cliente',
  'reportsList.date': 'Fecha',
  'reportsList.delivered': 'Entregado',
  'reportsList.noOrders': 'No hay pedidos',
  'reportsList.payment': 'Pago',
  'reportsList.phone': 'Teléfono',
  'reportsList.receiptNumber': 'N° recibo',
  'reportsList.registered': 'Registrado',
  'reportsList.reprint': 'Reimprimir',
  'reportsList.searchPlaceholder': 'Buscar...',
  'reportsList.status': 'Estado',
  'reportsList.totalReceipts': 'Total de recibos',
  'reportsList.totalRevenueExclCancelled': 'Ingresos totales (excl. cancelados)',

  // Servicios
  'service.carpetShort': 'Alfombra',
  'service.dryCleaningShort': 'Limpieza',
  'service.ironingShort': 'Planchado',
  'service.dyeingShort': 'Teñido',
  'service.shoeShineShort': 'Calzado',
  'service.tailoringShort': 'Sastrería',
  'service.washingShort': 'Lavado',

  // Configuración
  'settings.africa': 'África',
  'settings.americas': 'Américas',
  'settings.asia': 'Asia',
  'settings.asiaPacific': 'Asia-Pacífico',
  'settings.asianLanguages': 'Idiomas asiáticos',
  'settings.autoConnect': 'Conexión automática',
  'settings.browserNotSupported': 'Navegador no compatible',
  'settings.callerId': 'ID de llamada',
  'settings.clickConnectButton': 'Haga clic en Conectar',
  'settings.company': 'Empresa',
  'settings.connectDeviceInfo': 'Información del dispositivo',
  'settings.cut': 'Cortar',
  'settings.email': 'Correo electrónico',
  'settings.europe': 'Europa',
  'settings.europeanLanguages': 'Idiomas europeos',
  'settings.expenses': 'Gastos',
  'settings.feedForward': 'Avance de papel',
  'settings.formerSovietTurkic': 'Idiomas turcos ex-soviéticos',
  'settings.genericEscPos': 'ESC/POS genérico',
  'settings.howToConnect': 'Cómo conectar',
  'settings.integrations': 'Integraciones',
  'settings.invoices': 'Facturas',
  'settings.labelPrinter': 'Impresora de etiquetas',
  'settings.lastCall': 'Última llamada',
  'settings.majorCurrencies': 'Monedas principales',
  'settings.menu': 'Menú',
  'settings.middleEast': 'Oriente Medio',
  'settings.middleEastAfricanLanguages': 'Idiomas Oriente Medio y África',
  'settings.middleEastGulf': 'Golfo del Oriente Medio',
  'settings.notifications': 'Notificaciones',
  'settings.oceania': 'Oceanía',
  'settings.openDrawer': 'Abrir cajón',
  'settings.otherLanguages': 'Otros idiomas',
  'settings.paperWidth': 'Ancho de papel',
  'settings.phonePlaceholder': 'Ingrese el teléfono...',
  'settings.popularLanguages': 'Idiomas populares',
  'settings.printer': 'Impresora',
  'settings.printerConnect': 'Conectar impresora',
  'settings.printerConnected': 'Impresora conectada',
  'settings.printerConnection': 'Conexión de impresora',
  'settings.printerDisconnect': 'Desconectar impresora',
  'settings.printerModel': 'Modelo de impresora',
  'settings.printerNotConnected': 'Impresora no conectada',
  'settings.printerSettings': 'Configuración de impresora',
  'settings.receiptVisibleOnReceipt': 'Visible en el recibo',
  'settings.reports': 'Informes',
  'settings.reverse': 'Invertir',
  'settings.reverseTest': 'Prueba invertida',
  'settings.saveError': 'No se pudieron guardar los ajustes',
  'settings.saved': 'Ajustes guardados',
  'settings.selectDevice': 'Seleccionar dispositivo',
  'settings.successful': 'Exitoso',
  'settings.testPrint': 'Impresión de prueba',
  'settings.testPrintHeader': 'Encabezado de prueba',
  'settings.testPrinted': 'Prueba impresa',
  'settings.tickets': 'Tickets',
  'settings.turkey': 'Turquía',
  'settings.webSerialNotSupported': 'Web Serial no compatible',
  'settings.webSerialSupported': 'Web Serial compatible',
  'settings.zReport': 'Informe Z',

  // Registro
  'signup.errors.companyCodeRequired': 'Código de empresa requerido',
  'signup.errors.companyCodeTooShort': 'Código de empresa demasiado corto',
  'signup.errors.companyNameRequired': 'Nombre de empresa requerido',
  'signup.errors.emailInvalid': 'Correo electrónico inválido',
  'signup.errors.emailRequired': 'Correo electrónico requerido',
  'signup.errors.ownerNameRequired': 'Nombre del propietario requerido',
  'signup.errors.signupFailed': 'Registro fallido',

  // Estado
  'status.cancelled': 'Cancelado',
  'status.delivered': 'Entregado',
  'status.pending': 'Pendiente',
  'status.pickup_in_progress': 'Recogida en progreso',
  'status.pickup_pending': 'Recogida pendiente',
  'status.ready': 'Listo',
  'status.received': 'Recibido',

  // Suscripción
  'subscription.buyNow': 'Comprar ahora',
  'subscription.cancel': 'Cancelar suscripción',
  'subscription.contactSales': 'Contactar ventas',
  'subscription.contactSupport': 'Contactar soporte',
  'subscription.currentPlan': 'Plan actual',
  'subscription.currentUsage': 'Uso actual',
  'subscription.daysLeft': 'días restantes',
  'subscription.downgrade': 'Reducir plan',
  'subscription.endDate': 'Fecha de fin',
  'subscription.expired': 'Vencido',
  'subscription.expiredOn': 'Venció el',
  'subscription.expiresOn': 'Vence el',
  'subscription.features': 'Características',
  'subscription.loading': 'Cargando suscripción...',
  'subscription.monthly': 'Mensual',
  'subscription.monthlyLimit': 'Límite mensual',
  'subscription.noSubscription': 'Sin suscripción activa',
  'subscription.payNow': 'Pagar ahora',
  'subscription.plan': 'Plan',
  'subscription.popular': 'Popular',
  'subscription.pro': 'Pro',
  'subscription.renew': 'Renovar',
  'subscription.renewNow': 'Renovar ahora',
  'subscription.startDate': 'Fecha de inicio',
  'subscription.trial': 'Prueba',
  'subscription.trialDaysLeft': 'días de prueba restantes',
  'subscription.trialEnd': 'Fin de prueba',
  'subscription.upgrade': 'Mejorar plan',
  'subscription.yearly': 'Anual',

  // Sastrería
  'tailoring.addCustom': 'Agregar personalizado',
  'tailoring.astarDegisimi': 'Cambio de forro',
  'tailoring.belAyarı': 'Ajuste de cintura',
  'tailoring.cancel': 'Cancelar',
  'tailoring.cepDikimi': 'Costura de bolsillo',
  'tailoring.dugmeDikme': 'Coser botón',
  'tailoring.fermuarDegisimi': 'Cambio de cierre',
  'tailoring.icon': 'Ícono',
  'tailoring.kolBoyu': 'Largo de manga',
  'tailoring.omuzAyarı': 'Ajuste de hombro',
  'tailoring.operationName': 'Nombre de operación',
  'tailoring.pacaBoyu': 'Largo de dobladillo',
  'tailoring.price': 'Precio',
  'tailoring.save': 'Guardar',
  'tailoring.sokukDikimi': 'Costura de dobladillo',
  'tailoring.yama': 'Parche',

  // Tickets de soporte
  'tickets.closed': 'Cerrado',
  'tickets.translationError': 'Error de traducción',

  // Notificaciones toast
  'toast.cardPaymentFailed': 'Pago con tarjeta fallido. Inténtelo de nuevo.',
  'toast.cardPaymentSuccessMsg': 'Pago con tarjeta exitoso',
  'toast.connectionError': 'Error de conexión',
  'toast.connectionStatusError': 'Error de estado de conexión',
  'toast.customerAdded': 'Cliente agregado',
  'toast.customerError': 'Error de cliente',
  'toast.deliveryDatePastError': 'La fecha de entrega ya pasó',
  'toast.demoDataDeleteError': 'No se pudieron eliminar los datos demo',
  'toast.demoDataDeleted': 'Datos demo eliminados',
  'toast.disconnectError': 'Error al desconectar',
  'toast.logoTooLarge': 'El archivo de logo es demasiado grande',
  'toast.logoUploadError': 'No se pudo subir el logo',
  'toast.orderCreated': 'Pedido creado',
  'toast.orderError': 'Error de pedido',
  'toast.orderStatusUpdateError': 'No se pudo actualizar el estado',
  'toast.orderStatusUpdated': 'Estado actualizado',
  'toast.paymentStatusCheckErrorShort': 'No se pudo verificar el estado del pago.',
  'toast.pinChangeError': 'No se pudo cambiar el PIN',
  'toast.pinChanged': 'PIN cambiado',
  'toast.productAddedSimple': 'Producto agregado',
  'toast.productError': 'Error de producto',
  'toast.qrError': 'Error de QR',
  'toast.qrGenerated': 'QR generado',
  'toast.statsError': 'Error de estadísticas',
  'toast.uploadingLogo': 'Subiendo logo...',
  'toast.userAddError': 'No se pudo agregar el usuario',
  'toast.userAdded': 'Usuario agregado',
  'toast.userDeleteError': 'No se pudo eliminar el usuario',
  'toast.userDeleted': 'Usuario eliminado',
  'toast.userUpdateError': 'No se pudo actualizar el usuario',
  'toast.userUpdated': 'Usuario actualizado',
  'toast.usersLoadError': 'No se pudieron cargar los usuarios',
  'toast.whatsappConnected': 'WhatsApp conectado',
  'toast.whatsappDisconnected': 'WhatsApp desconectado',

  // Usuarios
  'users.delete': 'Eliminar usuario',
  'users.deleteError': 'No se pudo eliminar',
  'users.deleteUserTitle': 'Eliminar usuario',
  'users.deletingUser': 'Eliminando usuario...',
  'users.loadError': 'No se pudieron cargar los usuarios',
  'users.userDeleteError': 'Error al eliminar usuario',
  'users.userDeleted': 'Usuario eliminado',

  // WhatsApp
  'whatsapp.buyCredits': 'Comprar créditos',
  'whatsapp.connect': 'Conectar WhatsApp',
  'whatsapp.connected': 'Conectado',
  'whatsapp.creditPackages': 'Paquetes de créditos',
  'whatsapp.credits': 'Créditos',
  'whatsapp.creditsRemaining': 'créditos restantes',
  'whatsapp.disconnect': 'Desconectar',
  'whatsapp.messageHistory': 'Historial de mensajes',
  'whatsapp.messages': 'Mensajes',
  'whatsapp.noCredits': 'Sin créditos disponibles',
  'whatsapp.orderDelivered': 'Pedido entregado',
  'whatsapp.orderReady': 'Pedido listo',
  'whatsapp.preview': 'Vista previa',
  'whatsapp.receiptCreated': 'Recibo creado',
  'whatsapp.save': 'Guardar plantilla',
  'whatsapp.saved': 'Plantilla guardada',
  'whatsapp.scanQR': 'Escanear código QR',
  'whatsapp.sendTest': 'Enviar mensaje de prueba',
  'whatsapp.status': 'Estado',
  'whatsapp.template': 'Plantilla',
  'whatsapp.templates': 'Plantillas',
  'whatsapp.testFailed': 'Mensaje de prueba fallido',
  'whatsapp.testSent': 'Mensaje de prueba enviado',

  // Informe Z
  'zReport.byEmployee': 'Por empleado',
  'zReport.byProduct': 'Por producto',
  'zReport.byService': 'Por servicio',
  'zReport.cardPayments': 'Pagos con tarjeta',
  'zReport.cashIn': 'Entradas',
  'zReport.cashOut': 'Salidas',
  'zReport.cashPayments': 'Pagos en efectivo',
  'zReport.closingBalance': 'Saldo de cierre',
  'zReport.creditPayments': 'Pagos a crédito',
  'zReport.custom': 'Personalizado',
  'zReport.daily': 'Diario',
  'zReport.endDate': 'Fecha de fin',
  'zReport.freeOrders': 'Pedidos gratuitos',
  'zReport.generateReport': 'Generar informe',
  'zReport.monthly': 'Mensual',
  'zReport.newCustomers': 'Nuevos clientes',
  'zReport.noData': 'Sin datos para este período',
  'zReport.openingBalance': 'Saldo de apertura',
  'zReport.period': 'Período',
  'zReport.printReport': 'Imprimir informe',
  'zReport.returningCustomers': 'Clientes recurrentes',
  'zReport.selectDate': 'Seleccionar fecha',
  'zReport.startDate': 'Fecha de inicio',
  'zReport.title': 'Informe Z',
  'zReport.todayRegistrations': 'Registros de hoy',
  'zReport.totalCollected': 'Total cobrado',
  'zReport.totalItems': 'Total artículos',
  'zReport.totalOrders': 'Total pedidos',
  'zReport.totalRefunds': 'Total reembolsos',
  'zReport.totalRevenue': 'Ingresos totales',
  'zReport.totalSales': 'Ventas totales',
  'zReport.transferPayments': 'Transferencias',
  'zReport.weekly': 'Semanal',
  'zreport.card': 'Tarjeta',
  'zreport.cash': 'Efectivo',
  'zreport.date': 'Fecha',
  'zreport.orders': 'Pedidos',
  'zreport.print': 'Imprimir',
  'zreport.title': 'Informe Z',
  'zreport.total': 'Total',

  'zReport.cashBoxStartNote': 'Saldo inicial de caja',
  'zReport.todayCashNote': 'Efectivo recibido hoy',
  'zReport.branchCollectionsNote': 'Cobros propios + otras sucursales',
  'zReport.dailyExpensesNote': 'Gastos del día',
  'customerCard.balanceZero': 'El saldo ya es cero.',
  'customerCard.debtLabel': 'la deuda será eliminada',
  'customerCard.creditLabel': 'el crédito será eliminado',
  'customerCard.resetConfirm': 'El saldo se restablecerá ({label}). ¿Confirmar?',
  'customerCard.resetSuccess': 'Saldo restablecido',
  'customerCard.resetError': 'No se pudo restablecer el saldo',
  'customerCard.printTitle': 'Ficha de Cliente',
  'customerCard.heading': 'FICHA DE CLIENTE',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'DIRECCIÓN',
  'customerCard.printButton': 'Imprimir ficha de cliente',
  'customerCard.resetting': 'Restableciendo...',
  'customerCard.resetBalance': 'Restablecer saldo',
  'tailoring.loadError': 'No se pudieron cargar los precios',
  'tailoring.nameRequired': 'Por favor ingrese un nombre de operación',
  'tailoring.invalidPrice': 'Por favor ingrese un precio válido',
  'tailoring.addSuccess': '¡Nueva operación de sastrería agregada!',
  'tailoring.saveError': 'Error al guardar',
  'tailoring.deleteConfirm': '¿Está seguro de que desea eliminar esta operación?',
  'tailoring.deleteSuccess': 'Operación eliminada',
  'tailoring.deleteError': 'Error al eliminar',
  'tailoring.saveSuccess': '¡Precios de sastrería guardados!',
  'tailoring.addNewTitle': 'Agregar nueva operación de sastrería',
  'tailoring.operationNameLabel': 'Nombre de operación',
  'tailoring.priceLabel': 'Precio',
  'tailoring.iconLabel': 'Ícono (Emoji)',
  'tailoring.operationNamePlaceholder': 'Ej: Costura de cuello',
  'tailoring.savePricesHint': 'Haga clic en Guardar para guardar los precios',
  'tailoring.addCustomHint': 'Use el botón + para agregar una operación personalizada',
  'reportsList.title': 'Lista de recibos',
  'reportsList.startDate': 'Fecha de inicio',
  'reportsList.endDate': 'Fecha de fin',
  'reportsList.search': 'Buscar',
  'reportsList.loading': 'Cargando...',
  'reportsList.description': 'Se listan todos los recibos registrados o entregados en este rango de fechas',
  'reportsList.empty': 'No se encontraron recibos en este rango de fechas',
  'reportsList.changeDateRange': 'Seleccione un rango de fechas diferente',
  'reportsList.categoryBreakdown': 'Desglose por categoría',
  'reportsList.unknown': 'Desconocido',
  'reportsList.cancelReason': 'Motivo de cancelación:',
  'reportsList.excelDownloaded': 'Archivo Excel descargado',
  'reportsList.excelError': 'No se pudo crear el archivo Excel',
  'reportsList.totalReceipt': 'Total de recibos',
  'reportsList.activeReceipt': 'Recibos activos',
  'reportsList.loadError': 'No se pudo cargar la lista de recibos',
  'reportsList.dateError': 'La fecha de inicio no puede ser posterior a la fecha de fin',
  'charts.revenue': 'Ingresos',
  'charts.orders': 'Pedidos',
  'charts.pieces': 'Número de piezas',
  'charts.receipts': 'Número de recibos',
  'charts.loadError': 'No se pudieron cargar los datos',

  'customerStatement.selectDateRange': 'Seleccionar rango de fechas',
  'customerStatement.thisMonth': 'Este mes',
  'customerStatement.lastMonth': 'Mes pasado',
  'customerStatement.allTime': 'Todo el tiempo',
  'customerStatement.startDate': 'Fecha de inicio',
  'customerStatement.endDate': 'Fecha de fin',
  'customerStatement.printPDF': 'Imprimir extracto (PDF)',
  'customerStatement.title': 'EXTRACTO DE CUENTA',
  'customerStatement.customerName': 'Nombre del cliente',
  'customerStatement.phone': 'Teléfono',
  'customerStatement.address': 'Dirección',
  'customerStatement.openingBalance': 'Saldo inicial',
  'customerStatement.closingBalance': 'Saldo final',
  'customerStatement.description': 'Descripción',
  'customerStatement.type': 'Tipo',
  'customerStatement.debit': 'Débito',
  'customerStatement.credit': 'Crédito (cobrado)',
  'customerStatement.total': 'TOTAL',
  'customerStatement.cancelled': 'CANCELADO',
  'customerStatement.payment': 'Pago',
  'customerStatement.items': 'artículos',
  'customerStatement.noTransactions': 'No hay transacciones en el período seleccionado.',
  'customerStatement.statementDate': 'Fecha del extracto',

  'tailoring.subtitle': 'Aquí puede actualizar los precios de los servicios de sastrería',
  'tailoring.addNewDescription': 'Agregar un tipo de operación de sastrería personalizado',
  'tailoring.add': 'Agregar',
  'tailoring.savePrices': 'Guardar precios',
  'tailoring.default': 'Predeterminado',
  'tailoring.infoTitle': 'Información',
  'tailoring.info1': 'Después de cambiar los precios, haga clic en "Guardar precios"',
  'tailoring.info2': 'Con "Nueva Operación" puede agregar tipos de operaciones personalizadas',
  'tailoring.info3': 'Las operaciones personalizadas se pueden eliminar con el icono de papelera',
  'tailoring.info4': 'Estos precios se usan al crear pedidos con servicio de sastrería',
  'tailoring.info5': 'Puede establecer un precio separado para cada operación de sastrería',
  'tailoring.info6': 'Los precios se calculan automáticamente al agregar al carrito',

  'hardware.title': 'Tienda de Hardware',
  'hardware.subtitle': 'Impresoras de recibos, etiquetas y dispositivos Caller ID',
  'hardware.cart': 'Carrito',
  'hardware.infoTitle': 'Información',
  'hardware.infoText': 'Estos productos de hardware actualmente solo están disponibles para compra en Turquía. Se listan con fines informativos para otros países.',
  'hardware.myCart': 'Mi Carrito',
  'hardware.cartEmpty': 'Carrito vacío',
  'hardware.vatSuffix': '+ IVA',
  'hardware.total': 'Total',
  'hardware.checkout': 'Proceder al pago',
  'hardware.receiptPrinters': 'Impresoras de recibos',
  'hardware.receiptPrintersSubtitle': 'Impresoras térmicas 80mm con cortador automático',
  'hardware.compatibilityTitle': 'Compatibilidad CleandySoft',
  'hardware.receiptCompatText': 'Compatible con todas las impresoras térmicas 80mm con cortador automático.',
  'hardware.labelPrinters': 'Impresoras de etiquetas',
  'hardware.labelPrintersSubtitle': 'Impresoras matriciales, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Modelos probados',
  'hardware.labelCompatText': 'Probado para Epson TM-U220 y Bixolon SRP-270. Otras marcas o modelos pueden tener problemas.',
  'hardware.callerIdTitle': 'Dispositivos Caller ID',
  'hardware.callerIdSubtitle': 'Identificación de llamadas de clientes',
  'hardware.compatibilityNote': 'Nota de compatibilidad',
  'hardware.callerIdCompatText': 'Probado solo para modelo CIDShow 2 líneas. Otras marcas o modelos pueden funcionar pero no están garantizados.',
  'hardware.barcodeScanners': 'Lectores de códigos de barras',
  'hardware.barcodeScannerSubtitle': 'Lectores USB de códigos de barras y QR',
  'hardware.barcodeCompatText': 'Todos los lectores 2D pueden funcionar con CleandySoft. Los lectores en modo USB HID son compatibles automáticamente.',
  'hardware.driverDownloads': 'Descargas de controladores y software',
  'hardware.driverDownloadsText': 'Se recomienda descargar el controlador apropiado antes de conectar la impresora.',
  'hardware.onlyTurkey': 'Este producto solo está disponible para compra en Turquía',
  'hardware.addedToCart': '¡Añadido al carrito!',
  'hardware.available': 'Disponible',
  'hardware.info': 'Info',
  'hardware.features': 'Características',
  'hardware.addToCart': 'Añadir al carrito',
  'hardware.infoOnly': 'Solo informativo',

  // Payment dialog
  'order.selectPaymentMethod': 'Seleccione el método de pago',
  'payment.enterAmount': 'Introduzca el importe del pago',
  'payment.madePayments': 'Pagos realizados',
  'subscription.referralDesc': 'Cuando un amigo que invites se registre y se haga miembro, ganarás 1 mes extra. Solo enviar la invitación no basta.',
};
